<!-- Page content -->
<div class="container">
  <div id="pdfTable" #pdfTable>
    <!-- About Section -->
    <div *ngFor="let order of invoice.tickets" class="d-flex" id="about">
      <div class="p-4 w-100 grey-background">
        <a class="flex w-8" routerLink="/">
          <img
            *ngIf="translate.currentLang === 'ar'"
            src="/assets/images/evento-logo.svg"
            alt=""
            class="w-full mb-2"
          />
          <img
            *ngIf="translate.currentLang === 'en'"
            src="/assets/images/evento-logo-en.svg"
            alt=""
            class="w-full mb-2"
          />
        </a>
        <div class="my-2">
          <img
            crossorigin="anonymous"
            class="url"
            [src]="invoice.event.image.image.url"
          />
        </div>
        <div class="d-flex">
          <p id="title" class="mt-2">
            {{ "YourTicketToAttend" | translate }}
          </p>
        </div>
        <div class="d-flex">
          <p id="event-title">
            {{ helpers.getElementTranslatedName(invoice.event) }}
          </p>
        </div>
        <div class="d-flex">
          <p class="mb-0" id="event-address">
            {{ helpers.getElementTranslatedAddress(invoice.event) }}
          </p>
        </div>
        <div class="d-flex">
          <p id="event-address">
            {{ "TheEventStartsOn" | translate }}
            {{
              translate.currentLang === "ar"
                ? invoice.event.startDateAr
                : invoice.event.startDateEn
            }}
            {{ "to" | translate }}
            {{
              translate.currentLang === "ar"
                ? invoice.event.endDateAr
                : invoice.event.endDateEn
            }}
          </p>
        </div>
        <div class="white-background">
          <div class="d-flex justify-content-between p-2 align-items-center">
            <div class="details">
              <p class="name">
                {{ helpers.getElementTranslatedName(order) }}
              </p>
              <p class="date">
                {{
                  translate.currentLang === "ar" ? order.dateAr : order.dateEn
                }}
              </p>
              <p *ngIf="order.total > 0">
                <span
                  class="total"
                  [innerHTML]="
                    order.total
                      | customCurrency : 'SAR' : 'symbol' : '#e5263d' : 30
                  "
                >
                </span>
              </p>
              <p *ngIf="order.total == 0">
                <span class="total">{{ "free" | translate }} </span>
              </p>
            </div>

            <div class="qrcodFrame">
              <div
                class="container_"
                *ngIf="
                  order.approvalStatus === ApprovalStatusEnum.WaitingApproval ||
                  order.approvalStatus === ApprovalStatusEnum.DeclinedApproval
                "
              >
                <div class="tag">
                  <h6
                    *ngIf="
                      order.approvalStatus ===
                      ApprovalStatusEnum.WaitingApproval
                    "
                  >
                    {{ "WaitingApproval" | translate }}
                  </h6>
                  <h6
                    *ngIf="
                      order.approvalStatus ===
                      ApprovalStatusEnum.DeclinedApproval
                    "
                  >
                    {{ "Rejected" | translate }}
                  </h6>
                </div>
                <img
                  [src]="order.mutedQrCode"
                  alt=""
                  style="opacity: 0.4"
                  class="image"
                />
              </div>

              <img
                *ngIf="order.approvalStatus === ApprovalStatusEnum.Approved"
                [src]="order.generatedQrCode"
                alt=""
                style="opacity: 1.4"
              />
            </div>
          </div>
        </div>
        <div *ngIf="invoice.event.policies.length > 0">
          <div class="d-flex">
            <p id="event-title">
              {{ "Terms and Conditions" | translate }}
            </p>
          </div>

          <ul>
            <li
              class="term"
              *ngFor="let term of invoice.event.policies"
              [innerHTML]="helpers.getElementTranslatedName(term) | safeHTML"
            >
              {{ term }}
            </li>
          </ul>
        </div>
        <div class="sponsers d-flex mt-5 justify-content-center gap-3">
          <img
            style="width: 50px; height: 50px"
            crossorigin="anonymous"
            *ngFor="let sponser of invoice.event.eventSponsors"
            [src]="sponser.image.url"
          />
        </div>
      </div>
    </div>
  </div>
</div>
